import type { CampaignTargetType } from "@shared/common/types/campaign";

export const traverseTarget = (
  target: CampaignTargetType,
  checker: (target: CampaignTargetType) => void
) => {
  checker(target);

  if (target.type === "ROOT") {
    if (target.value) {
      traverseTarget(target.value, checker);
    }
    if (target.generated) {
      traverseTarget(target.generated, checker);
    }
  }

  if (target.type === "AND" || target.type === "OR") {
    target.value.forEach((targetValue) => {
      traverseTarget(targetValue, checker);
    });
  }
};

export const checkTargetFeaturePageVisitCount = (
  target: CampaignTargetType
) => {
  if (target.type !== "PAGE_VISIT_COUNT" && target.type !== "URL_VISIT_COUNT") {
    return false;
  }

  return target.period > 0 && target.count > 0;
};

export const checkTargetFeatureSitelVisitCount = (
  target: CampaignTargetType
) => {
  if (target.type !== "SITE_VISIT_COUNT") {
    return false;
  }

  return target.value.count > 0 && target.value.period > 0;
};

export const checkTargetFeatureSegment = (target: CampaignTargetType) => {
  if (target.type !== "SEGMENT") {
    return false;
  }

  return target.operator === "EQUAL" && !!target.value.id;
};

export const checkTargetFeatureUsers = (target: CampaignTargetType) => {
  if (target.type !== "USERS") {
    return false;
  }

  return target.operator === "INCLUDE";
};
